import React from 'react';
import PropTypes from 'prop-types';
import Body from '../Components/layout/Body';

const CONTEXTS_HELP = `
  <div>
    <p><strong>Purpose:</strong> Context relates to the environment(s) in which the client will be using their alternative access methods. 
    Relative to models of assistive technology, this is the E (Environment) in the SETT model, and forms the Context within the HAAT model. </p>
    <p>We’ve tried to include the aspects of context that tend to be important for just about everyone.  This includes all aspects of the physical environment, and the level of support from others that might be available or desirable.  
    Note that there may be additional aspects that are important to your client, and those may also emerge from the discussion you have during this section.  </p>
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.array, //[she, her, hers]
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their']
};

//content sub-component with unique content for this page
function IntroContent(props) {
  const firstName = props.firstName;
  const pronouns = props.pronouns;
  
  return(
      <p>We'll walk through these items to make sure everyone has a clear understanding 
          of where {firstName} needs access, what positions {pronouns[0]}'ll likely be in,
          and {pronouns[2]} preferences about support for setup and troubleshooting.
      </p>    
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function GatherInfoContextsIntro(props) {
  const firstName = props.firstName;
  const pronouns = props.pronouns;
  const onContinue = props.onContinue;

  console.log("rendering GatherInfoContextsIntro");

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used
    faIcon: "fa-users",
    pageSymbolClassName: "aa-section-symbol gather",

    title: `Now, let's look at the contexts of ${firstName}'s access needs.`,
    subTitle: "",
    learnMore: {linkText: "Learn More about why we ask about contexts",
                title: "Contexts",
                content: CONTEXTS_HELP
                },
    nextRoute: "", 
    sidebar: true
  }

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <IntroContent 
          firstName={firstName} 
          pronouns={pronouns}
        />
      }
      onContinue={onContinue} 
    />
    </>
  );
}

GatherInfoContextsIntro.propTypes = propTypes;
GatherInfoContextsIntro.defaultProps = defaultProps;

export default GatherInfoContextsIntro;